import React from "react";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
  ExportCSVButton
} from "react-bootstrap-table";
const createCustomSearchField = props => {
  return <SearchField placeholder="Buscar denuncia" />;
};
const createCustomExportCSVButton = props => {
  return <ExportCSVButton btnText="Exportar denuncias" />;
};
const options = {
  searchField: createCustomSearchField,
  exportCSVBtn: createCustomExportCSVButton,
  sizePerPage: 10,
  noDataText: "No hay datos para mostrar"
};
class TableMaster extends React.Component {
  handleBtnClick(e) {
    this.refs.table1.forceUpdate();
  }
  render() {
    return (
      <BootstrapTable
        options={{
          searchField: createCustomSearchField,
          sizePerPageList: [25, this.props.page_size],
          sizePerPage: 25,
          noDataText: "No hay datos para mostrar"
        }}
        ref="table1"
        data={this.props.rows}
        search
        pagination
        striped={true}
        hover={false}
        condensed={true}
      >
        <TableHeaderColumn
          dataField="item"
          width='40'
          isKey={true}
          dataSort={true}
          dataAlign="left"
          headerAlign="left"
        >N°</TableHeaderColumn>
        <TableHeaderColumn
          dataField="codigo"
          dataSort={true}
          dataAlign="left"
          headerAlign="left"
        >
          Código
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="departamento"
          dataAlign="left"
          headerAlign="left"
          dataSort={true}
        >
          Departamento
        </TableHeaderColumn>
        <TableHeaderColumn dataField="provincia" dataSort={true}>
          Provincia
        </TableHeaderColumn>
        <TableHeaderColumn dataField="distrito" dataSort={true}>
          Distrito
        </TableHeaderColumn>
        <TableHeaderColumn dataField="fecha_registro" dataSort={true}>
          Registrado el
        </TableHeaderColumn>
        <TableHeaderColumn dataField="sector" dataSort={true}>
          Sector
        </TableHeaderColumn>
        <TableHeaderColumn dataField="estado" dataSort={true}>
          Estado
        </TableHeaderColumn>
      </BootstrapTable>
    );
  }
}
export default TableMaster;
